<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title>Acción realizada :: <strong>{{action}}</strong></h1>
<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field *ngIf="action != 'Eliminar'; else elseTemplate">
                    <input cdkFocusInitial formControlName="Descripcion" placeholder="{{action}} Descripcion" matInput [(ngModel)]="local_data.descripcion">
                    <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row" *ngIf="action != 'Eliminar'">
            <div class="col-lg-12">
                <mat-slide-toggle color="primary" formControlName="TieneComision">Genera comisión</mat-slide-toggle>
                <p class="hint-comision">Si está activo, la bonificación entra al total de cálculo de la liquidación y reduce la comisión de la inmobiliaria. Si no, va a la cuenta del propietario sin comisión.</p>
            </div>
        </div>
    </form>
    <ng-template #elseTemplate>
        ¿Esta seguro que desea eliminar el registro <b>{{local_data.descripcion}}</b>?
    </ng-template><br>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" *appRole="['TiposBonificacion.Crear','TiposBonificacion.Modificar','TiposBonificacion.Eliminar']"  (click)="doAction()" [disabled]="!form.valid">{{action}}</button>
    <button mat-button (click)="closeDialog()" color="warn">Cancelar</button>
</div>
